import React, { useState } from 'react'
import './NeedHelp.css'

import Button from '../../../../components/Button/Button'
import Input from '../../../../components/Input/Input'

import searchIcon from '../../../../assets/header/searchIcon.png'

const NeedHelp = () => {
  const [formData, setFormData] = useState({
    contactEmail: '',
    contactNumber: '',
    date: '',
    time: '',
    reason: '',
    description: '',
    supportingAgent: '',
  })

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }))
  }

  const handleCancel = () => {
    setFormData({
      contactEmail: '',
      contactNumber: '',
      date: '',
      time: '',
      reason: '',
      description: '',
      supportingAgent: '',
    })
  }

  const handleConfirm = () => {
  }

  return (
    <div className="needhelp-config">
      <div className="needhelp-grid">
        <div className="needhelp-field">
          <label>Contact email*</label>
          <Input
            type="email"
            placeholder="Support Folio 1"
            value={formData.contactEmail}
            onChange={handleChange('contactEmail')}
            size="small"
            required
          />
        </div>

        <div className="needhelp-field">
          <label>Contact number*</label>
          <Input
            type="tel"
            placeholder="User name"
            value={formData.contactNumber}
            onChange={handleChange('contactNumber')}
            size="small"
            required
          />
        </div>

        <div className="needhelp-field">
          <label>Date*</label>
          <Input
            type="date"
            placeholder="11/16/1997"
            value={formData.date}
            onChange={handleChange('date')}
            size="small"
            required
          />
        </div>

        <div className="needhelp-field">
          <label>Time*</label>
          <Input
            type="time"
            placeholder=""
            value={formData.time}
            onChange={handleChange('time')}
            size="small"
            required
          />
        </div>

        <div className="needhelp-field">
          <label>Reason*</label>
          <Input
            type="text"
            placeholder="Name group"
            value={formData.reason}
            onChange={handleChange('reason')}
            size="small"
            required
          />
        </div>

        <div className="needhelp-field">
          <label>Description*</label>
          <Input
            type="text"
            placeholder="Description"
            value={formData.description}
            onChange={handleChange('description')}
            size="small"
            required
          />
        </div>
      </div>

      <div className="needhelp-agent">
        <div className="needhelp-field">
          <label>Supporting Agent*</label>
          <Input
            type="text"
            placeholder="Search agent"
            value={formData.supportingAgent}
            onChange={handleChange('supportingAgent')}
            icon={searchIcon}
            size="small"
            required
          />
        </div>
      </div>

      <div className="needhelp-actions">
        <div className="content_buttons">
          <Button
            onClick={handleCancel}
            variant="warning"
            fullWidth={true}
            borderRadius={20}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="primary"
            fullWidth={true}
            borderRadius={20}
          >
            Confirm
          </Button>
        </div>
      </div>
    </div>
  )
}

export default NeedHelp
